import { A } from '#app/components/typography/a'
import { H1 } from '#app/components/typography/h1.tsx'
import { H2 } from '#app/components/typography/h2.tsx'
import { Lead } from '#app/components/typography/lead'
import { P } from '#app/components/typography/p.tsx'
import { CommandLine } from '#app/old/components/typography/command-line'

export const handle = {
	breadcrumb: 'Installation',
}

export default function IntroductionRoute() {
	return (
		<div>
			<H1>Installation</H1>
			<Lead>
				VerveUI requires TailwindCSSv4 to be installed. Check out{' '}
				<A href="https://tailwindcss.com/docs/installation/framework-guides" target="_blank" rel="noreferrer">
					TailwindCSS's installation page
				</A>{' '}
				to install TailwindCSS for your framework.
			</Lead>
			<P>Here's everything you need to get started.</P>
			<H2>1. Install VerveUI</H2>
			<P>Download the zip file, unzip, and drag and drop the components to your folder.</P>
			<H2>2. Install Required Dependencies</H2>
			<CommandLine
				commands={[
					{
						type: 'command',
						text: 'npm i tsx cva tailwind-merge tailwindcss-animate tailwindcss-react-aria-components react-aria-components',
					},
				]}
			></CommandLine>

			{/* <H2>4. Install Icon Build Script</H2>
			<P>
				VerveUI uses an SVG sprite for{' '}
				<a href="https://benadam.me/thoughts/react-svg-sprites/" target="_blank" rel="noreferrer">
					optimal icon performance
				</a>
				. You'll find raw SVGs in the <Code>./other/svg-icons</Code> directory (once you can download VerveUI). These are then compiled into a sprite using the{' '}
				<Code>npm run build:icons</Code> script which generates the
				<Code>icon.svg</Code> file and an <Code>icons.json</Code> manifest file that allows Typescript to pick up the names of the icons.
			</P>
			<P>
				The SVGs used by default in VerveUI come from{' '}
				<a href="https://icons.radix-ui.com/" target="_blank" rel="noreferrer">
					icons.radix-ui.com
				</a>
				. You can download additional SVG icons from there, or provide your own. Once you've added new files in the directory, run <Code>npm run build:icons</Code> and you can then
				use the <Code>Icon</Code>
				component to render it. The icon prop is the name of the file without the <Code>.svg</Code> extension. We recommend using kebab-case filenames rather than PascalCase to avoid
				casing issues with different operating systems.
			</P>
			<P>
				By default, all the icons will have a height and width of <Code>1em</Code> so they should match the font-size of the text they're next to. You can also customize the{' '}
				<Code>size</Code>
				using the size prop.
			</P>
			<P>
				Add the build script to your <Code>package.json</Code>'s <Code>scripts</Code> object:
			</P>
			<CodeBlock
				code={`{
	"scripts": {
		"build:icons": "tsx ./other/build-icons.ts"
	}
}`}
				filename="tailwind.config"
				extension="ts"
				className="mt-4"
			/> */}
			<H2>3. All Done 🎉</H2>
			<P>Now you're ready to start building your application!</P>
		</div>
	)
}
